import React from "react";

import WordButton from "../WordButton";

import * as styles from "./GameGrid.module.css";

import { useSpring, animated } from "react-spring";
import { GameStatusContext } from "../../providers/GameStatusProvider";

function WordRow({ words }) {
  return (
    <div className={`grid grid-cols-4 gap-2`}>
      {words.map((word) => (
        <WordButton key={word} word={word} fullCandidateSize={words.length} />
      ))}
    </div>
  );
}

export function SolvedWordRow({ ...props }) {
  const DIFFICULTY_COLOR_MAP = {
    1: "#f9df6d", // yellow
    2: "#a0c35a", // green
    3: "#b0c4ef", // blue
    4: "#ba81c5", // purple
  };

  const color = `${DIFFICULTY_COLOR_MAP[props.difficulty]}`;

  const springProps = useSpring({
    from: {
      opacity: 0,
      transform: "translateY(100%)",
    },
    to: {
      opacity: 1,
      transform: "translateY(0%)",
    },
    delay: 250,
  });
  return (
    <animated.div style={springProps}>
      <div
        className="relative w-full"
        style={{
          paddingTop: "calc(25% - 6px)",
          backgroundColor: color,
          borderRadius: 6,
        }}
      >
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-2 text-black">
          <p className="font-sans font-extrabold uppercase tracking-wide text-sm sm:text-base">
            {props.category}
          </p>
          <p className="font-sans text-sm sm:text-base">
            {props.words.join(", ")}
          </p>
        </div>
      </div>
    </animated.div>
  );
}

function GameGrid({ gameRows, shouldGridShake, setShouldGridShake }) {
  const { submittedGuesses, isGameOver, isGameWon, solvedGameData } =
    React.useContext(GameStatusContext);

  React.useEffect(() => {
    const shakeEffect = window.setTimeout(() => {
      setShouldGridShake(false);
      // this timeout should probably be calculated since it depends on animation values for the grid shake
    }, 2000);

    // cleanup timeout
    return () => window.clearTimeout(shakeEffect);
  }, [submittedGuesses]);

  const isGameOverAndWon = isGameOver && isGameWon;
  const isGameActive = !isGameOver;
  const isGameActiveWithAnySolvedRows =
    isGameActive && solvedGameData.length > 0;

  return (
    <div>
      {(isGameOverAndWon || isGameActiveWithAnySolvedRows) && (
        <div className="grid gap-y-2 pb-2">
          {solvedGameData.map((solvedRowObj) => (
            <SolvedWordRow key={solvedRowObj.category} {...solvedRowObj} />
          ))}
        </div>
      )}
      {isGameActive && (
        <div className={`grid gap-y-2 ${shouldGridShake ? styles.shake : ""}`}>
          {gameRows.map((row, idx) => (
            <WordRow key={idx} words={row} />
          ))}
        </div>
      )}
    </div>
  );
}

export default GameGrid;
